import React, { useEffect } from 'react'
import { useRouter } from 'next/router'
import { Header } from 'semantic-ui-react'
import localization from 'containers/MyHealth/localization'
import getHealthItem from 'containers/MyHealth/items.ehr'
import NotificationBar from 'containers/MyHealth/components/MyHealthContentArea/NotificationBar'
import Modals from 'containers/MyHealth/components/MyHealthResultsContext/Modals'
import NoDataAvailableBar from 'containers/MyHealth/components/MyHealthContentArea/NoDataAvailableBar'

import MedicationsPrintModal from 'containers/MyHealth/components/MedicationsPrintModal'
import ImmunizationsPrintModal from 'containers/MyHealth/components/ImmunizationsPrintModal'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'

import _ from 'lodash'

import useMyHealthPolicyByModel from 'hooks/useMyHealthPolicy'
import withLocalization from '@web/helpers/localizationUtils'

const DEFAULT_HEALTH_ITEM = 'testResults'

const MyHealthContentArea = ({ setIsAdolescent, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const router = useRouter()
  let id = _.get(router.query, 'id', DEFAULT_HEALTH_ITEM)
  let healthItem = getHealthItem(id)

  if (!healthItem) {
    id = DEFAULT_HEALTH_ITEM
    healthItem = getHealthItem(DEFAULT_HEALTH_ITEM)
    router.push('myHealth')
  }
  const isAdolescent = !useMyHealthPolicyByModel(id)
  useEffect(
    () => {
      setIsAdolescent(isAdolescent)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAdolescent]
  )

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <Header style={styles.title}>
          <p>{t(id)}</p>
        </Header>
        {id === 'medications' && <MedicationsPrintModal />}
        {id === 'immunizations' && <ImmunizationsPrintModal />}
      </div>
      {healthItem.isShowDisclaimerMessage && (
        <NotificationBar
          textNormal={`${t('noteText')} `}
          textBold={t('noteTextBold')}
        />
      )}
      <div style={styles.contentArea} className='my-health-content-area'>
        {isAdolescent ? (
          <NoDataAvailableBar style={styles.noDataContainer} />
        ) : (
          <healthItem.Component Content={Modals[id]} />
        )}
      </div>
    </div>
  )
}

export default withLocalization(MyHealthContentArea, localization)
